<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const regulationsSection = ref<HTMLElement | null>(null);
const isVisible = ref(false);
let observer: IntersectionObserver | null = null;

onMounted(() => {
    if (!regulationsSection.value) {
        return;
    }

    observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                isVisible.value = true;
                observer?.unobserve(entry.target);
            });
        },
        {
            threshold: 0.05,
            rootMargin: "0px 0px -10% 0px"
        }
    );

    observer.observe(regulationsSection.value);
});

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
    <div id="regulations" ref="regulationsSection" :class="{ 'is-visible': isVisible }" class="pt-16 lg:pt-32 pb-16 px-4 text-default-white text-center">
        <div class="regulations-block">
        <h2 class="regulations-title text-[2.5rem] lg:text-6xl pb-4 lg:pb-8">REGULAMIN</h2>
        <div class="w-28 lg:w-52 h-px bg-default-white/70 mx-auto mb-14"></div>
        <a role="button" class="cta-button block leading-none text-xs !px-28 w-fit text-center font-medium tracking-wider" href="/Regulamin.pdf" download>POBIERZ</a>
        </div>
    </div>
</template>

<style scoped>
.regulations-block {
    opacity: 0;
    transform: translateY(20px);
    transition: transform 0.7s ease, opacity 0.7s ease;
}

.regulations-title {
    letter-spacing: 4px;
    opacity: 0;
    transform: translateY(16px);
    transition:
        letter-spacing 0.8s ease,
        transform 0.8s ease,
        opacity 0.8s ease;
}

.cta-button {
    position: relative;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.cta-button::before {
    content: "";
    position: absolute;
    inset: 0 auto 0 -140%;
    width: 42%;
    background: linear-gradient(115deg, transparent 0%, rgba(255, 255, 255, 0.16) 35%, rgba(255, 255, 255, 0.45) 50%, transparent 100%);
    transform: skewX(-22deg);
    transition: left 0.45s ease;
    pointer-events: none;
}

.cta-button:hover {
    transform: scale(1.03);
    box-shadow: 0 14px 34px rgba(237, 27, 35, 0.28);
}

.cta-button:hover::before {
    left: 135%;
}

#regulations.is-visible .regulations-block {
    opacity: 1;
    transform: translateY(0);
}

#regulations.is-visible .regulations-title {
    letter-spacing: 10px;
    opacity: 1;
    transform: translateY(0);
}

</style>
